__webpack_require__.p = "https://static.age.awaze.com/search-mfe/179305e/_next/";